import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom';

import { UserAuth } from '../context/AuthContext'


import { db } from "../firebase"
import {
  doc,
  collection,
  onSnapshot,
  setDoc,
  deleteDoc,
  query,
  where,
  getDocs,
  orderBy,
  getDoc,
  serverTimestamp,
  FieldValue,
  arrayUnion,
  updateDoc
} from "firebase/firestore"

const CreateNewLic = () => {
  let params = useParams();
  const navigate = useNavigate()

  const [error, setError] = useState("");

  const { user } = UserAuth();
  const currentUrl = window.location.href;


  //breytir available lic í firebase og navigatear á /aurora/lic/:name/:machineid
  const updateLicense = async () => {
    console.log("CreateNewLic.jsx: Starting updateLicense. params:", params);
    let machineid = {
      license1: params.machineid,
    };

    console.log("CreateNewLic.jsx: params.numlic is:", params.numlic);

    if (params.numlic == 2) {
      machineid = {
        license2: params.machineid
      };
    }

    let responseData = "";

    try {
      let pluginProduct = localStorage.getItem('plugin_product') || 'Refract';

      // Case-sensitivity fix: The C++ plugin and Firebase function expect "Refract" (Capital R)
      if (pluginProduct.toLowerCase() === 'refract') {
        pluginProduct = 'Refract';
      } else if (pluginProduct.toLowerCase() === 'duck') {
        pluginProduct = 'Duck';
      }

      const userEmail = user.email;
      // Use the new generateLicense function which supports our {MachineID}|{Email}|{ProductID} signing format
      const functionURL = `https://us-central1-ts-web-5390d.cloudfunctions.net/generateLicense`;

      const response = await fetch(`${functionURL}?machine_id=${params.machineid}&product=${pluginProduct}&user_email=${userEmail}&json=true`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Server response wasnt OK: ' + response.statusText);
      }

      const json = await response.json();
      responseData = json.signature;

      if (!responseData) {
        throw new Error('Signature was empty from server');
      }
    } catch (error) {
      console.error('Error making server call:', error);
      setError("Failed to generate license signature: " + error.message);
      return; // Stop the flow, prevent navigating to a malformed URL
    }

    console.log(responseData)

    if (params.numlic == 2) {
      machineid = {
        license2: responseData
      };
    }
    else {
      machineid = {
        license1: responseData
      };
    }

    await setDoc(doc(db, "purchasedProducts", params.licenseid), machineid, {
      merge: true,
    });

    const pluginProduct = localStorage.getItem('plugin_product');
    const basePath = pluginProduct ? pluginProduct.toLowerCase() : 'aurora';
    const finalNavUrl = `/${basePath}/lic/1/${responseData}/${user.email}`;
    console.log("CreateNewLic.jsx: Navigating to CompletedReload via:", finalNavUrl);
    navigate(finalNavUrl);
  };

  useEffect(() => {
    updateLicense().catch((error) => {
      setError(error.message);
      console.error("Error updating license:", error);
    });
  }, []);


  return (
    <div>
      <div className="salepage__img">
        {/*<img src={bgImg} alt="img" className='salepage__imgsize' />*/}
      </div>
      {!error && (
        <div className="spinner">
          <div className="spinner-dot"></div>
        </div>
      )}
      <div style={{ color: 'white', padding: '20px', textAlign: 'center', fontFamily: 'sans-serif' }}>
        {error ? (
          <div>
            <h3>Error Details:</h3>
            <p>{error}</p>
            <p style={{ fontSize: '12px', marginTop: '10px' }}>Note: Please ensure the Firebase functions and the React app have both been deployed after the recent updates, as CORS headers were just added to the server.</p>
          </div>
        ) : (
          <p>Generating License...</p>
        )}
        <br />
        <p style={{ fontSize: '10px', color: '#555' }}>{currentUrl}</p>
      </div>
    </div>
  )
}

export default CreateNewLic